import React from "react";

interface TabItem {
    id: string;
    name: string;
    isActive?: boolean;
    content: React.ReactNode;
}

interface Props {
    tabItems: TabItem[];
}

function Tabs(props: Props) {
    const { tabItems } = props;
    return (
        <div className="cmp-tabs">
            {tabItems.length > 0 ? (
                <ul className="cmp-tabs__nav nav nav-pills mb-3" role="tablist">
                    {tabItems.map((item, index) => {
                        return (
                            <li key={index} className="cmp-tabs__nav__item nav-item">
                                <a
                                    className={`cmp-tabs__nav__link nav-link  ${
                                        item.isActive ? "active" : index === 0 ? "active" : ""
                                    }`}
                                    data-toggle="pill"
                                    href={`#${item.id}`}
                                    role="tab"
                                    aria-controls={item.id}
                                    aria-selected={item.isActive ? item.isActive : index === 0}
                                >
                                    {item.name}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            ) : (
                ""
            )}

            {tabItems.length > 0 ? (
                <div className="cmp-tabs__content tab-content p-3">
                    {tabItems.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`tab-pane fade ${
                                    item.isActive ? "show active" : index === 0 ? "show active" : ""
                                }`}
                                id={item.id}
                                role="tabpanel"
                                aria-labelledby={item.id}
                            >
                                {item.content}
                            </div>
                        );
                    })}
                </div>
            ) : (
                ""
            )}
        </div>
    );
}

export default Tabs;
